import React, { useContext } from "react";
import SubHeader from "../../../components/subheader/SubHeader";
import "./Others.scss";
import StackedColumnsChart from "../../../components/cost/stackedcolumnschart/StackedColumnsChart";
import PieChartCost from "../../../components/cost/piechart/PieChartCost";
import TotalYearCard from "../../../components/totalrevenue/totalyearcard/TotalYearCard";
import TotalQuarterCard from "../../../components/totalrevenue/totalquarterard/TotalQuarterCard";
import TotalMonthCard from "../../../components/totalrevenue/totalmonthcard/TotalMonthCard";
import RegionalRevenueDonutChart from "../../../components/revenue/donutchart/DonutChart";
import RevenueTable from "../../../components/revenue/revenuetable/RevenueTable";
import RevenueBarChart from "../../../components/revenue/revenuebarchart/RevenueBarChart";
import DonutChartLine from "../../../components/cost/donutchartline/DonutChartLine";
import TableDDCompensation from "../../../components/cost/tableddcompensation/TableDDCompensation";
import BarChartNegative from "../../../components/cost/onboardingfeechart/BarChartNegative";
import TableNegative from "../../../components/cost/onboardingfeechart/TableNegative";
import { AppContext } from "../../../context/Context";
import DonutChartNegative from "../../../components/cost/onboardingfeechart/DonutChartNegative";
import { getQuarterByMonth, createRevenueCardYearTitle, createRevenueCardQuarterTitle, createRevenueCardMonthTitle } from "../../../utils/format";
const Others = () => {
  const { data, fromDate, toDate } = useContext(AppContext);

  const shortcutimport = data?.cost?.other ?? {};

  const allData = data.cost?.other.costtotalotheramount || [];
  
  const firstRevenueYearMonth =
        allData.length > 0 ? allData[0].year_month : null;
    
  const lastRevenueYearMonth =
    allData.length > 0 ? allData[allData.length - 1].year_month : null;

  const computeOtherAmountYear= (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === "All" || !toDate) {
      total =
        data.cost?.other.costtotalotheramount?.reduce(
          (sum, item) => sum + (item.goods_sold_cost || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split("-")[0]);
      const toYear = parseInt(toDate.split("-")[0]);

      total =
        data.cost?.other.costtotalotheramount
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split("-")[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  const computeOtherAmountQuarter = (fromDate, toDate, data) => {
    if (!data.cost?.other.costtotalotheramount) return 0;

    // Handle "All"
    if (fromDate === "All" || !toDate) {
      return data.cost?.other.costtotalotheramount.reduce(
        (sum, item) => sum + (item.goods_sold_cost || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split("-").map(Number);
    const [toYear, toMonth] = toDate.split("-").map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.cost?.other.costtotalotheramount
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split("-").map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0);

    return total;
  };

  const computeOtherMountCurrentMonth = (data) => {
    const lines = data.cost?.other.costtotalotheramountfilter;
    if (!Array.isArray(lines)) return "0.00";

    const total = lines.reduce(
      (sum, item) => sum + (item.goods_sold_cost || 0),
      0
    );

    return total;
  };

  const computeOtherAmountPreviousMonth = (data) => {
    if (!data.cost?.other.costtotalpreviousamount) return 0;
    return data.cost?.other.costtotalpreviousamount.reduce(
      (sum, item) => sum + item.goods_sold_cost,
      0
    );
  }

  // Helper functions
  const safeArray = (arr) => (Array.isArray(arr) ? arr : []);

  const computeTotalDDCompensation = (fromDate, toDate, data) => {
    const DDCompensationSafeArray = safeArray(
      data?.cost?.other?.costtotaldetailddcompensation
    );

    if (DDCompensationSafeArray.length === 0) return 0;

    if (fromDate === "All") {
      return DDCompensationSafeArray.reduce(
        (acc, curr) => acc + curr.goods_sold_cost,
        0
      );
    } else {
      return DDCompensationSafeArray
        .filter((item) => {
          const itemDate = item.year_month;
          return fromDate <= itemDate && itemDate <= toDate;
        })
        .reduce((acc, curr) => acc + curr.goods_sold_cost, 0);
    }
  };

  const computeTotalSumOnboardingFee = (fromDate, toDate, data) => {
  const onboardingFeeArray = safeArray(
    data?.cost?.other?.costtotaldetailonboardingfee
  );

  if (onboardingFeeArray.length === 0) return 0;

  if (fromDate === "All") {
    return onboardingFeeArray.reduce(
      (acc, curr) => acc + curr.goods_sold_cost,
      0
    );
  } else {
    return onboardingFeeArray
      .filter((item) => {
        const itemDate = item.year_month;
        return fromDate <= itemDate && itemDate <= toDate;
      })
      .reduce((acc, curr) => acc + curr.goods_sold_cost, 0);
  }
};

  const computeTotalSumRevenueShare = (fromDate, toDate, data) => {
    const revenueShareArray = safeArray(
      data?.cost?.other?.costtotaldetailrevenueshare
    );

    if (revenueShareArray.length === 0) return 0;

    if (fromDate === "All") {
      return revenueShareArray.reduce(
        (acc, curr) => acc + curr.goods_sold_cost,
        0
      );
    } else {
      return revenueShareArray
        .filter((item) => {
          const itemDate = item.year_month;
          return fromDate <= itemDate && itemDate <= toDate;
        })
        .reduce((acc, curr) => acc + curr.goods_sold_cost, 0);
    }
  };

  // Stack Column Renaming
  const renameMap = {
    month_year: "month",
    "DD Compensation": "revenue",
    "Onboarding Fee": "yellowdecrease",
    "Revenue Share": "greenIncrease",
  };

  const grouped = safeArray(shortcutimport.costdataStackcolumns)
    .reduce((acc, item) => {
      const { year_month, cogs_type, goods_sold_cost } = item;

      if (!acc[year_month]) {
        acc[year_month] = { month_year: year_month };
      }

      if (!acc[year_month][cogs_type]) {
        acc[year_month][cogs_type] = 0;
      }

      acc[year_month][cogs_type] += goods_sold_cost;
      return acc;
    }, {});

  const renamedGrouped = Object.values(grouped).map((obj) => {
    const renamedObj = {};
    for (const key in obj) {
      renamedObj[renameMap[key] ?? key] = obj[key];
    }
    return renamedObj;
  });  

  // Region/State/Market helpers
  const sumByRegion = (data) =>
    safeArray(data).reduce((acc, item) => {
      acc[item.regional] =
        (acc[item.regional] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

  const sumByState = (data) =>
    safeArray(data).reduce((acc, item) => {
      acc[item.state] = (acc[item.state] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

  const sumByMarket = (data) =>
    safeArray(data).reduce((acc, item) => {
      acc[item.market] =
        (acc[item.market] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

  const sumByState1 = (data) =>
    safeArray(data).reduce((acc, item) => {
      acc[item.state] = (acc[item.state] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

  const sumByMarket1 = (data) =>
    safeArray(data).reduce((acc, item) => {
      acc[item.market] = (acc[item.market] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

  // Color map
  const regionColors = {
    "Region 2": "#118DFF",
    "Region 3": "#4766D9",
    "Region 1": "#FDC500",
    "(None)": "#9ca3af",
  };

  // Region revenue
  const formattedData = Object.entries(
    sumByRegion(shortcutimport.costdataotherddcompensation)
  )
    .map(([region, totalRevenue]) => ({
      region,
      totalRevenue,
      indicator: regionColors[region] ?? "#000000",
    }))
    .sort((a, b) => b.totalRevenue - a.totalRevenue);

  const formattedDataRemoveNone = Object.entries(
    sumByRegion(shortcutimport.costdataotherddcompensation)
  )
    .map(([region, totalRevenue]) => ({
      name: region,
      value: totalRevenue,
    }))
    .filter((item) => item.name !== "(None)")
    .sort((a, b) => b.value - a.value);

  // State revenue
  const revenueStateArray = Object.entries(
    sumByState1(shortcutimport.costdataotherstatedd)
  )
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 10);

  // Market revenue
  const revenueMarketArray = Object.entries(
    sumByMarket1(shortcutimport.costdataothermarketdd)
  )
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 10);

  // Onboarding fee by region
  const formattedDataOnboardingFee = Object.entries(
    sumByRegion(shortcutimport.costdataotherregionalonboarding)
  )
    .map(([region, totalRevenue]) => ({
      region,
      totalRevenue,
      indicator: regionColors[region] ?? "#000000",
    }))
    .sort((a, b) => b.totalRevenue - a.totalRevenue);

  const formattedDataOnBoardingFeeRemoveNone = Object.entries(
    sumByRegion(shortcutimport.costdataotherregionalonboarding)
  )
    .map(([region, totalRevenue]) => ({
      name: region,
      value: Math.abs(totalRevenue),
    }))
    .sort((a, b) => b.value - a.value);  

  // Onboarding fee by state
  const revenueStateOnBoardingFeeArray = Object.entries(
    sumByState(shortcutimport.costdataotherstateonboarding)
  )
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => a.revenue - b.revenue)
    .slice(0, 10);

  // Onboarding fee by market
  const revenueMarketOnBoardingFeeArray = Object.entries(
    sumByMarket(shortcutimport.costdataothermarketonboarding)
  )
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => a.revenue - b.revenue)
    .slice(0, 10);

  // Revenue Share by region
  const groupedRegion = safeArray(
    shortcutimport.costdataotherregionalrevenueshare
  ).reduce((acc, item) => {
    const { regional, goods_sold_cost } = item;
    acc[regional] = (acc[regional] || 0) + goods_sold_cost;
    return acc;
  }, {});

  const colors = ["#2196F3", "#FFC107", "#4F6BF7"];
  const totalRevenue = Object.values(groupedRegion).reduce(
    (sum, val) => sum + val,
    0
  );

  const resultArrayRegion = Object.entries(groupedRegion)
    .map(([type, total]) => ({
      name: type,
      value: total,
      percent: totalRevenue
        ? parseFloat(((total / totalRevenue) * 100).toFixed(2))
        : 0,
    }))
    .sort((a, b) => b.value - a.value)
    .map((item, index) => ({
      ...item,
      color: index < 3 ? colors[index] : "#E0E0E0",
    }));

  // Revenue Share by plan
  const sumByPlan = (data) =>
    safeArray(data).reduce((acc, item) => {
      acc[item.plan] = (acc[item.plan] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

  const formattedDataPlan = Object.entries(
    sumByPlan(shortcutimport.costdataotherplanrevenueshare)
  )
    .map(([region, totalRevenue]) => ({ name: region, value: totalRevenue }))
    .sort((a, b) => b.value - a.value);

  const total = formattedDataPlan.reduce((acc, item) => acc + item.value, 0);

  const formattedDataPlanWithPercent = formattedDataPlan.map((item) => ({
    ...item,
    percentage: parseFloat(((item.value / total) * 100).toFixed(2)),
  }));

  // Revenue Share by state and market
  const revenueStateRevenueShareFeeArray = Object.entries(
    sumByState1(shortcutimport.costdataothestaterevenueshare)
  )
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 10);

  const revenueMarketRevenueShareFeeArray = Object.entries(
    sumByMarket1(shortcutimport.costdataothermarketrevenueshare)
  )
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 10);

  const sumByNameAgent = (data) => {
    const summed = safeArray(data).reduce((acc, item) => {
      acc[item.name] = (acc[item.name] || 0) + item.goods_sold_cost;
      return acc;
    }, {});

    return Object.entries(summed)
      .map(([name, total]) => ({ name, total }))
      .sort((a, b) => b.total - a.total);
  };

  return (
    <div className="frame-others">
      <SubHeader title="COST OF GOODS SOLD (OTHER AMOUNTS)" />

      <div className="frame-others-block1">
        <div className="frame-block1-other-left-top-left">
          <TotalYearCard
            title={createRevenueCardYearTitle(firstRevenueYearMonth, lastRevenueYearMonth, fromDate, toDate)}
            amount={computeOtherAmountYear(fromDate, toDate, data)}
          />
        </div>
        <div className="frame-block2-other-left-top-left">
          <TotalQuarterCard
            title={createRevenueCardQuarterTitle(firstRevenueYearMonth, lastRevenueYearMonth, fromDate, toDate)}
            amount={computeOtherAmountQuarter(fromDate, toDate, data)}
          />
        </div>

        <div className="frame-block3-other-left-top-left">
          <TotalMonthCard
            title={createRevenueCardMonthTitle(firstRevenueYearMonth, lastRevenueYearMonth, fromDate, toDate)}
            amount={computeOtherMountCurrentMonth(data)}
            previousMonthAmount={computeOtherAmountPreviousMonth(data)}
          />
        </div>
        
      </div>

      <div className="frame-others-block2">
        <div className="frame-others-block2-top ">
          <div className="frame-cost-block2-top-title">
            <p>
            </p>
          </div>
          <div className="frame-others-block2-top-box-total">
            <div className="frame-others-block2-top-item-box">
              <div className="frame-point-title">
                <div className="frame-point-dd" />
                <p className="frame">DD COMPENSATION</p>
              </div>

              <h3 className="frame-h3-dd">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(computeTotalDDCompensation(fromDate, toDate, data))}
              </h3>
            </div>

            <div className="frame-others-block2-top-item-box">
              <div className="frame-point-title">
                <div
                  className="frame-point-dd"
                  style={{ backgroundColor: "#dad104" }}
                />
                <p className="frame">ONBOARDING FEE</p>
              </div>

              <h3 className="frame-h3-dd" style={{ color: "#dad104" }}>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(computeTotalSumOnboardingFee(fromDate, toDate, data))}
              </h3>
            </div>
            <div className="frame-others-block2-top-item-box">
              <div className="frame-point-title">
                <div
                  className="frame-point-dd"
                  style={{ backgroundColor: "#6ddd65" }}
                />
                <p className="frame">REVENUE SHARE</p>
              </div>

              <h3 className="frame-h3-dd" style={{ color: "#6ddd65" }}>
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(computeTotalSumRevenueShare(fromDate, toDate, data))}
              </h3>
            </div>
          </div>
        </div>

        <StackedColumnsChart datas={renamedGrouped} />
      </div>

      <h1>DD COMPENSATION</h1>

      <div className="frame-others-block3">
        <div className="frame-others-block3-left">
          <h3>TOTAL DD COMPENSATION BY REGIONAL</h3>
          <div
            className="frame-donut-chart-main-other"
            style={{ height: "400px ", width: "400px" }}
          >
            <RegionalRevenueDonutChart
              colors={["#118DFF", "#4766D9", "#FDC500"]}
              data={formattedDataRemoveNone}
            />
          </div>
          <div className="frame-table-other">
            <RevenueTable data={formattedData} />
          </div>
        </div>
        <div className="frame-others-block3-right">
          <h3>TOTAL DD COMPENSATION BY DISTRICT DIRECTORS</h3>
          <TableDDCompensation
            data={sumByNameAgent(
              shortcutimport?.costdataotherddcompensationbydistrict
            )}
          />
        </div>
      </div>
      <div className="frame-others-block4">
        <div className="frame-others-block4-left">
          <h3>TOP 10 STATES WITH HIGHEST DD COMPENSATION</h3>
          <RevenueBarChart
            height={700}
            firstColor="#E7DFF7"
            secondColor="#6B89F7"
            data={revenueStateArray}
          />
        </div>
        <div className="frame-others-block4-right">
          <h3>TOP 10 MARKET WITH HIGHEST DD COMPENSATION</h3>
          <RevenueBarChart
            height={700}
            firstColor="#E7DFF7"
            secondColor="#6B89F7"
            data={revenueMarketArray}
          />
        </div>
      </div>

      <h1>ONBOARDING FEE</h1>
      <div className="frame-others-block5">
        <div className="frame-others-block5-box">
          <h3 style={{ paddingTop: "20px" }}>
            TOTAL ONBOARDING FEE BY REGIONAL
          </h3>
          <div style={{ height: "450px ", width: "450px" }}>
            <DonutChartNegative
              colors={["#118DFF", "#4766D9", "#FDC500"]}
              data={formattedDataOnBoardingFeeRemoveNone}
            />
          </div>
          <div className="frame-table-other">
            <TableNegative data={formattedDataOnboardingFee} />
          </div>
        </div>
        <div className="frame-others-block5-box">
          <h3>TOP 10 STATES BY HIGHEST ONBOARDING FEE</h3>
          <BarChartNegative
            height={700}
            firstColor="#E7DFF7"
            secondColor="#6B89F7"
            data={revenueStateOnBoardingFeeArray}
          />
        </div>
        <div className="frame-others-block5-box">
          <h3>TOP 10 MARKETS BY HIGHEST ONBOARDING FEE</h3>
          <BarChartNegative
            height={700}
            firstColor="#E7DFF7"
            secondColor="#6B89F7"
            data={revenueMarketOnBoardingFeeArray}
          />
        </div>
      </div>
      <h1>REVENUE SHARE</h1>
      <div className="frame-others-block6">
        <div className="frame-others-block6-left">
          <h3>TOTAL REVENUE SHARE BY PLAN TYPE</h3>
          <PieChartCost data={formattedDataPlanWithPercent} />
        </div>
        <div className="frame-others-block6-right">
          <h3>TOTAL REVENUE SHARE BY REGIONAL</h3>
          <DonutChartLine data={resultArrayRegion} heights="400px" />
        </div>
      </div>
      <div className="frame-others-block7">
        <div className="frame-others-block7-left">
          <h3>TOP 10 STATES WITH HIGHEST REVENUE SHARE</h3>
          <RevenueBarChart
            height={700}
            firstColor="#E7DFF7"
            secondColor="#6B89F7"
            data={revenueStateRevenueShareFeeArray}
          />
        </div>
        <div className="frame-others-block7-right">
          <h3>TOP 10 MARKETS WITH HIGHEST REVENUE SHARE</h3>
          <RevenueBarChart
            height={700}
            firstColor="#E7DFF7"
            secondColor="#6B89F7"
            data={revenueMarketRevenueShareFeeArray}
          />
        </div>
      </div>
    </div>
  );
};

export default Others;
